<button
  mat-button
  class="simple-failover-btn"
  ixTest="initiate-failover"
  [color]="color"
  [disabled]="disabled"
  (click)="openDialog()"
>
  {{ 'Initiate Failover' | translate }}
</button>
